var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "app"
    }
  }, [_c("b-navbar", {
    attrs: {
      type: "dark",
      variant: _vm.navColor
    }
  }, [_c("b-navbar-brand", {
    attrs: {
      href: "#"
    }
  }, [_vm._v("Jerry Accounting 2.0")]), _vm._v(" "), _vm.showReturnButton ? _c("b-navbar-nav", {
    staticClass: "ml-auto"
  }, [_c("b-button", {
    attrs: {
      variant: "outline-light"
    },
    on: {
      click: _vm.goToMenu
    }
  }, [_vm._v("Retour")])], 1) : _vm._e()], 1), _vm._v(" "), _c("b-container", {
    staticClass: "py-4",
    attrs: {
      fluid: ""
    }
  }, [_c("transition", {
    attrs: {
      name: "fade",
      mode: "out-in"
    }
  }, [_c("router-view")], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };